import { Button, Chip, Divider, IconButton } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

type ColorStatus = 'waiting-for-payment' | 'paid' | 'price-clarification';

const getColorStatus = (color: ColorStatus, theme: Theme) => {
  switch (color) {
    case 'waiting-for-payment':
      return { backgroundColor: '#eee', color: '#191c2999' };
    case 'price-clarification':
      return { backgroundColor: '#fb8901', color: '#fff' };
    case 'paid':
      return { backgroundColor: '#00a947', color: '#fff' };
    default:
      return { backgroundColor: theme.palette.error.main, color: '#fff' };
  }
};

export const useStyles = makeStyles(() => ({
  invoice: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 24,
    paddingRight: 12,
    gap: 24,
  },
  invoiceItem: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: ({ mode }: { mode: string }) =>
      mode === 'edit' ? 'calc(100% - 56px) 32px' : '100%',
    gap: 24,
    '@media (max-width: 1495px)': {
      marginBottom: 20,
    },
    '@media (max-width: 1320px)': {
      display: 'flex',
      flexDirection: 'column-reverse',
    },
  },
  fields: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '50% 1fr 1fr',
    alignItems: 'top',
    gap: 24,
    '@media (max-width: 1495px)': {
      marginBottom: 20,
    },
    '@media (max-width: 1320px)': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  fileName: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 13,
    color: '#65657B',
    margin: '7px 30px 0px 0px',
  },
  errorFile: {
    color: '#d32f2f',
    marginTop: 10,
    fontSize: 13,
    '@media (max-width: 1495px)': {
      marginBottom: 20,
    },
  },
  file: {
    display: 'flex',
    width: '45%',
  },
  fileScreenLess: {
    display: 'flex',
    width: '100%',
    marginBottom: 20,
  },
}));

export const styles = {
  attachIcon: {
    transform: 'rotate(45deg)',
    marginRight: 5,
  },
  attachButton: {
    padding: '10px 15px',
  },
  addIcon: {
    marginRight: 5,
  },
  addButton: {
    padding: '10px 15px',
    marginBottom: 20,
  },
  deleteButton: {
    marginLeft: 10,
  },
  deleteButtonScreenLess: {
    marginLeft: 'auto',
    display: 'flex',
  },
};

export const StyledChip = styled(Chip)<{ status: string }>(({ theme, status }) => ({
  backgroundColor: getColorStatus(status as ColorStatus, theme).backgroundColor,
  color: getColorStatus(status as ColorStatus, theme).color,
}));

export const StyledDeleteButton = styled(IconButton)<{ isScreenLess: boolean }>(
  ({ theme, isScreenLess }) => ({
    marginLeft: isScreenLess ? 'auto' : 'unset',
    display: 'flex',
    width: 32,
    height: 32,
    color: theme.palette.error.main,
  })
);

export const StyledAddButton = styled(Button)(() => ({
  marginBottom: 24,
  width: 125,
  height: 32,
  borderRadius: 16,
}));

export const StyledButtonText = styled('span')(() => ({
  position: 'relative',
  top: '1.5px',
}));

export const StyledAttachFileButton = styled(Button)(() => ({
  width: 177,
  height: 32,
  borderRadius: 16,
}));

export const StyledLinkWrapper = styled('div')<{ file?: boolean }>(({ theme, file }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: file ? 'column' : 'unset',
}));

export const StyledLinkContainer = styled('div')(() => ({
  width: '100%',
  overflowWrap: 'break-word',
}));

export const StyledDivider = styled(Divider)(() => ({
  marginBottom: 11,
}));
